import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'sideFilter';
export const CLICK_EVENT = 'click';
export const SIDEPANEL_OPEN = 'side-panel--open';
export const FILTER_SIDEBAR_ID = '#js-side-filter-panel';
export const FILTER_CLOSE_CLASS = '.js-side-filter-panel-close';

export const DEFAULTS = {

};

const setEventListeners = ($el) => {
  $el.on(CLICK_EVENT, (e) => {
    e.preventDefault();
    e.stopPropagation();
    $(FILTER_SIDEBAR_ID).addClass(SIDEPANEL_OPEN);
    $('#js-side-filter-panel .js-accordion__label').eq(0).focus();
    Keyboard.trapFocus($('#js-side-filter-panel'));
  });

  $(FILTER_SIDEBAR_ID).on(CLICK_EVENT, FILTER_CLOSE_CLASS, (e) => {
    e.preventDefault();
    e.stopPropagation();
    $(FILTER_SIDEBAR_ID).removeClass(SIDEPANEL_OPEN);
    Keyboard.releaseFocus($('#js-side-filter-panel'));
    $('#js-filter-btn').focus();
  });

  $('body').on('click.js-filter-btn', (e) => {
    if ($(e.target).parents(FILTER_SIDEBAR_ID).length === 0) {
      $(FILTER_SIDEBAR_ID).removeClass(SIDEPANEL_OPEN);
    }
  });
};

export default function sideFilter(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, sideFilter);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/side-filter.js